/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { generatePDF } from "../shared/pdf/generatePDF";
import { api } from "../../config/api";
import { message } from "antd";
import { validateFormData } from "./helperComponent/Funtions";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import CustomButton from "../shared/common/customButton";
import NewQuoteForm from "./NewQuoteForm";

const AddQuotesForNewUser = ({ settingsData }) => {
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [templateSelected, setTemplateSelected] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [Total, setTotal] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");

  const creationDate = new Date();
  const getDefaultValidityDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date.toISOString().split('T')[0];
  };

  const [formData, setFormData] = useState({
    status: "pending",
    sendStatus: true,
    quoteNumber: "",
    validityDate: getDefaultValidityDate() || "",
    userId: "",
    name: "",
    email: "",
    password: "", // Added password field
    postalCode: "",
    address: "",
    city: "",
    country: "",
    loadAddress: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    unloadAddress: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    unloadAddress_CompanyName: "",
    modeOfTransfer: "By Road",
    cargoValue: { value: "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: totalWeight,
    description: "",
    creationDate: creationDate.toISOString(),
    services: [
      {
        numberOfItem: "",
        description: "",
        exclVAT: "",
      },
    ],
    total: Total,
    subTotal: 0,
    vatPercentage: "",
    vatAmount: 0,
    insurance: 0,
    currency: "USD", // Default currency set to USD
    loadState: "",
    unloadState: "",
  });

  const areMandatoryFieldsFilled = () => {
    const requiredFields = [
      "loadCountry",
      "unloadCountry",
      "description",
      "pcsPackage",
      "cargoValue",
      "cifValue",
      "currency", // Added currency to required fields
    ];
    for (let field of requiredFields) {
      if (!formData[field]) {
        return false;
      }
    }
    if (formData.pcsPackage.length === 0) {
      return false;
    }
    for (let pkg of formData.pcsPackage) {
      if (
        !pkg.quantity ||
        !pkg.weight.value ||
        !pkg.length.value ||
        !pkg.width.value ||
        !pkg.height.value
      ) {
        return false;
      }
    }
    return true;
  };

  const validateQuoteFormData = (formData) => {
    const errors = [];
    const invalidFields = [];
    const requiredFields = [
      "name",
      "email",
      "postalCode",
      "address",
      "city",
      "country",
      "loadCountry",
      "loadCity",
      "unloadCity",
      "unloadCountry",
      "description",
      "loadPostalCode",
      "unloadPostalCode",
      "loadAddress",
      "unloadAddress",
      "currency", // Added currency to validation
    ];
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === "") {
        errors.push(`${field} is required and cannot be empty`);
        invalidFields.push(field);
      }
    });
    // VAT is optional; only flag when negative
    if (formData.vatPercentage !== "" && formData.vatPercentage < 0) {
      errors.push("VAT Percentage must be greater than or equal to 0");
      invalidFields.push("vatPercentage");
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      errors.push("Invalid email format");
      invalidFields.push("email");
    }
    if (formData.pcsPackage.length === 0) {
      errors.push("At least one package is required");
      invalidFields.push("pcsPackage");
    } else {
      formData.pcsPackage.forEach((pkg, index) => {
        if (!pkg.quantity) invalidFields.push(`quantity-${index}`);
        if (!pkg.weight.value) invalidFields.push(`weight-${index}`);
        if (!pkg.length.value) invalidFields.push(`length-${index}`);
        if (!pkg.width.value) invalidFields.push(`width-${index}`);
        if (!pkg.height.value) invalidFields.push(`height-${index}`);
        if (
          !pkg.quantity ||
          !pkg.weight.value ||
          !pkg.length.value ||
          !pkg.width.value ||
          !pkg.height.value
        ) {
          errors.push(`Goods Package ${index + 1} details are incomplete`);
        }
      });
    }
    if (!formData.quoteNumber || formData.quoteNumber.trim() === "") {
      errors.push("Quote Number is required");
      invalidFields.push("quoteNumber");
    }
    return { errors, invalidFields };
  };

  const highlightInvalidFields = (invalidFields) => {
    invalidFields.forEach((field) => {
      const element = document.getElementById(field);
      if (element) {
        element.style.border = "2px solid red";
      }
    });
    setTimeout(() => {
      invalidFields.forEach((field) => {
        const element = document.getElementById(field);
        if (element) {
          element.style.border = "";
        }
      });
    }, 3000);
  };

  const validateMandatoryFields = () => {
    const mandatoryFields = ["unloadCountry", "description", "pcsPackage", "currency"]; // Added currency
    for (let field of mandatoryFields) {
      if (!formData[field]) {
        return false;
      }
    }
    if (formData.pcsPackage.length === 0) {
      return false;
    }
    for (let pkg of formData.pcsPackage) {
      if (
        !pkg.quantity ||
        !pkg.weight.value ||
        !pkg.length.value ||
        !pkg.width.value ||
        !pkg.height.value
      ) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (settingsData?.quoteNumber_Prefix) {
      setFormData(prevData => ({
        ...prevData,
        quoteNumber: settingsData.quoteNumber_Prefix
      }));
    }
  }, [settingsData]);

  useEffect(() => {
    let subTotal = 0;
    let discountableSubTotal = 0;

    formData.services.forEach((service) => {
      const totalForService =
        parseFloat(service.numberOfItem || 1) * parseFloat(service.exclVAT || 0);
      subTotal += totalForService;

      const desc = (service.description || "").trim().toLowerCase();
      const isTaxOrDuty =
        desc === "vat" ||
        desc.includes("duty") ||
        desc.includes("duties") ||
        desc.includes("tax");

      if (!isTaxOrDuty) {
        discountableSubTotal += totalForService;
      }
    });

    // Calculate Discount — applies only to base services subtotal, excluding VAT/Duties/Taxes
    const rawDiscount = parseFloat(discountValue) || 0;
    let discountAmount = 0;
    if (rawDiscount > 0) {
      if (discountType === "percentage") {
        discountAmount = (discountableSubTotal * rawDiscount) / 100;
      } else {
        discountAmount = rawDiscount;
      }
      // Clamp so discount never exceeds discountableSubTotal
      discountAmount = Math.min(discountAmount, discountableSubTotal);
    }
    const discountedSubTotal = subTotal - discountAmount;

    // Calculate VAT Amount (calculated on base subtotal, NOT discounted)
    const vatPercentage = parseFloat(formData.vatPercentage || 0);
    const vatAmount = vatPercentage === 0 ? 0 : (subTotal * vatPercentage) / 100;
    let total = discountedSubTotal + vatAmount;
    let InsuranceTotal = total;
    const insuranceValue = parseFloat(formData.insurance || 0);
    if (insuranceValue !== 0) {
      InsuranceTotal += insuranceValue;
    }
    const formattedTotal = InsuranceTotal.toFixed(2);

    // Discount metadata
    const discountData = discountAmount > 0
      ? {
          type: discountType,
          value: rawDiscount,
          amount: parseFloat(discountAmount.toFixed(2)),
          servicesSubtotalBeforeDiscount: discountableSubTotal,
        }
      : null;

    setTotal(formattedTotal);
    setFormData((prevData) => ({
      ...prevData,
      subTotal: subTotal.toFixed(2),
      vatAmount: vatAmount.toFixed(2),
      total: formattedTotal,
      discount: discountData,
    }));
  }, [formData.services, formData.vatPercentage, formData.insurance, discountType, discountValue]);

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);
    setTotalWeight(total);
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total,
    }));
  }, [formData.pcsPackage, totalWeight]);

  const downloadPDF = async () => {
    const { errors, invalidFields } = validateQuoteFormData(formData);
    if (errors.length > 0) {
      toast.error("Please fill all required fields");
      highlightInvalidFields(invalidFields);
      return;
    }
    setPdfLoading(true);
    try {
      if (!validateMandatoryFields()) {
        toast.error("Please fill all mandatory fields");
        return;
      }
      const blob = await generatePDF(formData);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${formData.quoteNumber}.pdf`;
      link.click();
    } catch (error) {
      console.error(error);
      toast.error("Error generating PDF. Please try again later.");
    } finally {
      setPdfLoading(false);
    }
  };

  const handleAddData = async (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    const { errors, invalidFields } = validateQuoteFormData(formData);
    if (
      !formData.cargoValue.value ||
      parseFloat(formData.cargoValue.value) <= 0
    ) {
      errors.push("Cargo Value must be a positive number");
      invalidFields.push("cargoValue");
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      errors.push("CIF Value must be a positive number");
      invalidFields.push("cifValue");
    }
    const serviceErrors = {};
    formData.services.forEach((service, index) => {
      if (!service.numberOfItem || parseFloat(service.numberOfItem) <= 0) {
        serviceErrors[`service_${index}_numberOfItem`] = true;
      }
      if (!service.description || service.description.trim() === "") {
        serviceErrors[`service_${index}_description`] = true;
      }
    });
    if (errors.length > 0) {
      toast.error("Please fill all required fields");
      highlightInvalidFields(invalidFields);
      return;
    }
    try {
      setLoading(true);
      const errors = validateFormData(formData, [
        "unloadCountry",
        "loadCountry",
      ]);
      if (Object.keys(errors).length > 0) {
        Object.values(errors).forEach((errorMessage) => {
          message.error(errorMessage);
        });
      } else {
        // Modified password logic here
        const password = formData.password && formData.password.trim() !== ""
          ? formData.password
          : "1Un!on5olut!0ns";

        // FIXED: Include currency in userData
        const userData = {
          name: formData.name,
          email: formData.email,
          address: formData.address,
          city: formData.city,
          postalCode: formData.postalCode,
          country: formData.country,
          password: password, // Use conditional password
          currency: formData.currency, // ADDED: Currency from formData
          role: "user",
        };
        const res = await api.post("/users", userData);
        if (res.status === 201) {
          let { uid } = res.data;
          toast.success("User data saved successfully!");
          setFormData((prevData) => ({
            ...prevData,
            userId: uid,
          }));
          const createRes = await api.post("/firestore/quotes/create-with-quote-number", {
            ...formData,
            userId: uid,
            vatPercentage: isNaN(parseFloat(formData.vatPercentage || 0))
              ? 0
              : parseFloat(formData.vatPercentage || 0),
            quoteCreatedDate: new Date().toISOString(),
          });
          const savedQuoteNumber = createRes?.data?.quoteNumber;
          if (!savedQuoteNumber) {
            throw new Error("Failed to assign quote number");
          }
          setAttemptedSubmit(false);
          toast.success("Quotes data saved successfully!");
          window.location.reload();
        } else {
          toast.error("Failed to create user. Please try again later.");
        }
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.warning("User already exist");
    } finally {
      setLoading(false);
    }
  };

  const handleDraft = async (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);
    const { errors, invalidFields } = validateQuoteFormData(formData);
    if (errors.length > 0) {
      toast.error("Please fill all required fields");
      return;
    }
    try {
      const errors = validateFormData(formData, [
        "unloadCountry",
        "loadCountry",
      ]);
      if (Object.keys(errors).length > 0) {
        Object.values(errors).forEach((errorMessage) => {
          message.error(errorMessage);
        });
      } else {
        // Modified password logic here too
        const password = formData.password && formData.password.trim() !== ""
          ? formData.password
          : "1Un!on5olut!0ns";

        // FIXED: Include currency in userData for draft as well
        const userData = {
          name: formData.name,
          email: formData.email,
          address: formData.address,
          city: formData.city,
          postalCode: formData.postalCode,
          country: formData.country,
          password: password, // Use conditional password
          currency: formData.currency, // ADDED: Currency from formData
          role: "user",
        };
        const updatedData = {
          ...formData,
          vatPercentage: isNaN(parseFloat(formData.vatPercentage || 0))
            ? 0
            : parseFloat(formData.vatPercentage || 0),
          sendStatus: false,
          quoteCreatedDate: new Date().toISOString(),
        };
        const res = await api.post("/users", userData);
        if (res.status === 201) {
          let { uid } = res.data;
          toast.success("User data saved successfully!");
          setFormData((prevData) => ({
            ...prevData,
            userId: uid,
          }));
          const createRes = await api.post("/firestore/quotes/create-with-quote-number", {
            ...updatedData,
            userId: uid,
          });
          const savedQuoteNumber = createRes?.data?.quoteNumber;
          if (!savedQuoteNumber) {
            throw new Error("Failed to assign quote number");
          }
          toast.success("Quotes data saved successfully!");
          window.location.reload();
        } else {
          toast.error("Failed to create user. Please try again later.");
        }
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.warning("User already exist");
    } finally {
      setLoading1(false);
    }
  };

  return (
    <div>
      <NewQuoteForm
        formData={formData}
        setFormData={setFormData}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        templateSelected={templateSelected}
        setTemplateSelected={setTemplateSelected}
        attemptedSubmit={attemptedSubmit}
        isPopupOpen={isPopupOpen}
        setIsPopupOpen={setIsPopupOpen}
        areMandatoryFieldsFilled={areMandatoryFieldsFilled}
        discountType={discountType}
        discountValue={discountValue}
        onDiscountTypeChange={setDiscountType}
        onDiscountValueChange={setDiscountValue}
      />
      <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4 ">
        <div className="flex gap-2 items-center">
          <CustomButton
            label="Save and Send"
            onClick={handleAddData}
            loading={loading}
          />
          <CustomButton
            label="Save "
            onClick={handleDraft}
            loading={loading1}
          />
        </div>
        <PDFDownloadButton onClick={downloadPDF} loading={pdfLoading} />
      </div>
    </div>
  );
};

export default AddQuotesForNewUser;
